(() => {
  const GOAL = 3000000;
  const START_AMOUNT = 0;
  const START_BACKERS = 0;
  const AUTO_TARGET = 418650;
  const AUTO_BACKERS_TARGET = 1376;
  const AUTO_DURATION = 5000;

  const STORAGE_KEY = "bp_analog_crowdfunding_state_v6";
  const REWARD_KEY = "bp_analog_reward_v5";
  const REWARD_UNLOCK_KEY = "bp_analog_reward_unlocked_v4";

  const REWARD_SYNC_QUEUE_KEY = "bp_analog_reward_sync_queue_v2";
  const ACTIVITY_API_URL = "https://mng.beyond-power.com/shopify/support/activity/points/add";
  const ACTIVITY_ID = "fool_day_activity_2026";
  const ACTIVITY_API_PATH = "/shopify/support/activity/points/add";
  const ACTIVITY_SIGN_TOKEN = "K7qLl5j1NBFIPTI2jpJqYb2s";

  const amountEl = document.getElementById("bp-amount");
  const progressBarEl = document.getElementById("bp-progress-bar");
  const fundedTextEl = document.getElementById("bp-funded-text");
  const backerPreviewEl = document.getElementById("bp-backer-preview");
  const backerCountEl = document.getElementById("bp-backer-count");
  const liveTextEl = document.getElementById("bp-live-text");
  const updateBoxEl = document.getElementById("bp-update-box");
  const modalEl = document.getElementById("bp-pledge-modal");

  const stepTiersEl = document.getElementById("bp-step-tiers");
  const stepRevealNoticeEl = document.getElementById("bp-step-reveal-notice");
  const stepClaimEl = document.getElementById("bp-step-claim");
  const openClaimStepBtn = document.getElementById("bp-open-claim-step");

  const claimRewardEl = document.getElementById("bp-claim-reward");
  const claimQuoteEl = document.getElementById("bp-claim-quote");
  const claimSuccessNoteEl = document.getElementById("bp-claim-success-note");
  const claimFormCompactEl = document.getElementById("bp-claim-form-compact");
  const claimSuccessEmailEl = document.getElementById("bp-claim-success-email");

  if (
    !amountEl ||
    !progressBarEl ||
    !fundedTextEl ||
    !backerCountEl ||
    !liveTextEl ||
    !modalEl
  ) return;

  const liveMessages = window.liveMessages = [
  "<strong>Steve B.</strong> just backed The Pendulum. Then backed it again. Steve, you only need one.",
  "<strong>Jimmy D.</strong> shared the page to 3 group chats in under 40 seconds. We have analytics, Jimmy.",
  "📧 Anonymous email from a competing brand: “How do you guys keep coming up with this stuff?” We don’t know either.",
  "<strong>William M.</strong> just backed The Meridian and changed his LinkedIn bio to “Analog Investor.”",
  "<strong>Thomas G.</strong> pledged, then immediately asked if we accept Canadian dollars. Yes, Thomas.",
  "⚠️ An unnamed smart gym company just screenshotted this page. We saw the referral traffic. Hi.",
  "<strong>Andrew L.</strong> backed The Standard. His plates now weigh what they claim to. Revolutionary.",
  "<strong>u/Admirable-Bar-722</strong> shared the post to r/homegym. The username continues to check out.",
  "<strong>David K.</strong> just pledged from what appears to be a work laptop. Bold move, David.",
  "📧 A brand that recently launched a “revolutionary” cable machine just added our page to their next product meeting agenda. We’re flattered.",
  "<strong>Ryan L.</strong> backed the full collection. We’re legally required to tell you he did this unprompted.",
  "<strong>Daniel G.</strong> just pledged and left a note: “Finally, a crowdfunding campaign that will actually ship.”",
  "⚠️ A company that rhymes with “obedience” just viewed this page 14 times from the same IP address. We hope they’re taking notes — they usually do.",
  "<strong>Jason D.</strong> shared the campaign. Caption: “These people are unhinged and I respect it.”",
  "<strong>u/GamesnGunZ</strong> pledged from the subreddit and commented “this is why I chose BP.” We’re not crying.",
  "📧 An anonymous competitor DM’d us on Instagram: “Do you guys ever run out of ideas?” Short answer: no. Long answer: also no.",
  "<strong>Victor W.</strong> tried to pledge twice. Victor, your generosity has been noted and your second charge reversed.",
  "⚠️ A fitness tech startup currently running a Kickstarter with 14 months of delays just retweeted our page. The audacity.",
  "<strong>Henry J.</strong> just backed The Pendulum and texted the group chat: “They actually did it.” We actually did.",
  "Backer #402 just asked for a refund. We’ve placed him in a digital waiting room with 4,000 other optimists.",
  "📦 Shipping update: delivery currently scheduled for Q4 2026. Or 2029. Let’s just say “eventually-ish.”",
  "📧 <strong>Speedy</strong> just emailed asking for our CAD files. We sent them a recipe for Originality.",
  "<strong>Igor Z.</strong> just tried to pay us in protein powder. We’re considering it. Gym chalk accepted next quarter.",
  "<strong>Kevin S.</strong> just backed the project. Pretty sure he’s using the company credit card. HR has been CC’d.",
  "<strong>Michael R.</strong> just pledged $10,000. We think it’s a glitch, but we’re keeping it.",
  "<strong>Batman</strong> backed the whole set. He’s currently explaining the “investment” to Alfred and Lucius. We wish him well.",
  "⚠️ Our payment processor just flagged the campaign for “suspicious optimism.”",
  "<strong>Anand P.</strong> just requested express shipping. Sir, the product doesn’t exist yet.",
  "📧 A brand that recently described their cable machine as “AI-powered” just emailed 👀.",
  "<strong>Jesse D.</strong> asked if he could pay in monthly installments. For a product that doesn’t exist. We admire the commitment.",
  "<strong>Kyle J.</strong> JUST BACKED EVERYTHING IN ALL CAPS. ON BRAND, KYLE.",
  "⚠️ Our legal team just reviewed this page. They had “concerns.” We had snacks. The meeting went well.",
  "<strong>Ronald S.</strong> just referred 6 friends. None of them know what they’re backing. All of them pledged anyway.",
  "<strong>Steve B.</strong> asked when the Analog Collection will be compatible with the Beyond+ app. Steve. Steve, no.",
  "📦 Warehouse update: we’ve cleared shelf space for 0 units. Production remains on track.",
  "<strong>u/GamesnGunZ</strong> just posted a full unboxing video. Of what, we genuinely don’t know.",
  "A company that’s been “shipping Q3” for three consecutive years just reported our campaign for false advertising. 🤪",
  "<strong>Adam K.</strong> pledged, then immediately emailed support asking about warranty coverage. On a kettlebell. That doesn’t exist.",
  "<strong>Jimmy D.</strong> just backed the barbell and asked if it comes with firmware updates. Nuh uh, Jimmy sweetie, no.",
  "<strong>Bella W.</strong> bypassed the public campaign and used a fake employee discount code. HR’s onto it.",
  "<strong>Brody L.</strong> backed the entire collection. New characters added to his cinematic universe.",
  "<strong>Chris F.</strong> just backed The Pendulum and asked if we thought people would understand the tech. Duh!",
  "<strong>Salt</strong> just pledged $1.00. He’s waiting for the “Gotcha!” email. Keep waiting, buddy.",
  "<strong>Salt</strong> just pledged another $1.00. Testing our refund system now. We see you.",
  "<strong>Gavin S.</strong> just pledged. He spent more time on this fake site than his actual work. We’re not mad, just impressed.",
  "<strong>YC</strong> just claimed the “Last” kettlebell. For the tenth time today. Our counter is... “innovative.”",
  "<strong>Salt</strong> is now live on Discord reviewing a product that doesn’t exist. 47 people are watching. We love this community."
];

  const socialBoosts = [1200, 1800, 2400, 3200, 4500, 6200, 7800];
  const quotes = [
    "The bar doesn't care about your feelings. Pick it up.",
    "Rest days are earned, not scheduled.",
    "Somewhere, someone is warming up with your max. Smile about it.",
    "Consistency is louder than intensity.",
    "You don't have to love the set. You have to finish it.",
    "Iron doesn't lie, and neither does your training log.",
    "Your body keeps a more honest record than your brain does.",
    "Train, b*tch.",
    "The weight doesn't get lighter. You get less dramatic about it.",
    "Nobody ever regretted a session they showed up for.",
    "Motivation is a guest. Discipline lives here.",
    "If the warm-up feels heavy, the warm-up feels heavy. Keep going.",
    "You're one training cycle away from not recognizing your old numbers.",
    "Respect the process. The results are just receipts.",
    "Every PR started as a plate you were scared to load.",
    "Gravity doesn't negotiate.",
    "The best program is the one you actually do.",
    "Shut up and train. (Politely.)",
    "Your future self is watching. Don't make it weird.",
    "The iron remembers, even when you skip a week."
  ];

  const saved = (() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    } catch (e) {
      return null;
    }
  })();

  const state = {
    amount: saved?.amount ?? START_AMOUNT,
    backers: saved?.backers ?? START_BACKERS,
    autoBootDone: saved?.autoBootDone ?? false,
    supportCount: saved?.supportCount ?? 0
  };

  let pendingClaim = null;
  let klaviyoWatchTimer = null;
  let claimSubmitting = false;

  function formatMoney(value) {
    return "$" + Math.round(value).toLocaleString("en-US");
  }

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function render() {
  const rawPercent = (state.amount / GOAL) * 100;
  const barPercent = clamp(rawPercent, 0, 100);

  amountEl.textContent = formatMoney(state.amount);
  progressBarEl.style.width = barPercent + "%";
  fundedTextEl.textContent = rawPercent.toFixed(1) + "% funded";

  if (backerPreviewEl) {
    backerPreviewEl.textContent = state.backers.toLocaleString("en-US") + " backers";
  }

  backerCountEl.textContent = state.backers.toLocaleString("en-US");
  saveState();
}

  function animateTo(targetAmount, targetBackers, duration = 1200, onDone) {
    const startAmount = state.amount;
    const startBackers = state.backers;
    const amountDelta = targetAmount - startAmount;
    const backerDelta = targetBackers - startBackers;
    const start = performance.now();

    function frame(now) {
      const progress = clamp((now - start) / duration, 0, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      state.amount = Math.round(startAmount + amountDelta * eased);
      state.backers = Math.round(startBackers + backerDelta * eased);
      render();

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else if (typeof onDone === "function") {
        onDone();
      }
    }

    requestAnimationFrame(frame);
  }

function cycleLiveMessages() {
  let i = 0;
  liveTextEl.innerHTML = liveMessages[i];

  setInterval(() => {
    liveTextEl.classList.add("is-exiting");

    setTimeout(() => {
      i = (i + 1) % liveMessages.length;
      liveTextEl.classList.remove("is-exiting");
      liveTextEl.classList.add("is-entering");
      liveTextEl.innerHTML = liveMessages[i];

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          liveTextEl.classList.remove("is-entering");
        });
      });
    }, 220);
  }, 3200);
}

  function passiveGrowthLoop() {
    setInterval(() => {
      const bump = socialBoosts[Math.floor(Math.random() * socialBoosts.length)];
      const backerBump = Math.random() < 0.7 ? 1 : 2;
      state.amount += bump;
      state.backers += backerBump;
      render();
    }, 6500);
  }

  function showUpdate(message) {
    if (!updateBoxEl) return;
    updateBoxEl.textContent = message;
    updateBoxEl.classList.add("is-visible");
  }

  function weightedPickDigit(weights) {
    const total = weights.reduce((sum, item) => sum + item.weight, 0);
    let roll = Math.random() * total;

    for (const item of weights) {
      roll -= item.weight;
      if (roll <= 0) return item.digit;
    }

    return weights[weights.length - 1].digit;
  }

  function weightedReward() {
    const unitTensHundredsWeights = [
      { digit: 9, weight: 10 },
      { digit: 8, weight: 10 },
      { digit: 7, weight: 10 },
      { digit: 6, weight: 10 },
      { digit: 5, weight: 10 },
      { digit: 4, weight: 10},
      { digit: 3, weight: 10},
      { digit: 2, weight: 10},
      { digit: 1, weight: 10},
      { digit: 0, weight: 10}
    ];

    const thousandsWeights = [
      { digit: 9, weight: 0.01 },
      { digit: 8, weight: 0.02 },
      { digit: 7, weight: 0.02 },
      { digit: 6, weight: 0.02 },
      { digit: 5, weight: 0.03 },
      { digit: 4, weight: 0.9 },
      { digit: 3, weight: 2 },
      { digit: 2, weight: 10 },
      { digit: 1, weight: 38 },
      { digit: 0, weight: 50 }
    ];

    const ones = weightedPickDigit(unitTensHundredsWeights);
    const tens = weightedPickDigit(unitTensHundredsWeights);
    const hundreds = weightedPickDigit(unitTensHundredsWeights);
    const thousands = weightedPickDigit(thousandsWeights);

    const credits = Number(`${thousands}${hundreds}${tens}${ones}`);

    let tier = "Covert tier: Early Supporter";
    let chip = "Most likely drop";
    let sub = "A clean little bonus for backing a product line that absolutely does not exist. Valid through April 7.";

    if (credits >= 7000) {
      tier = "Covert tier: Legendary Backer";
      chip = "Ultra rare drop";
      sub = "You unlocked the least defendable reward in the system. The covert team salutes you. Valid through April 7.";
    } else if (credits >= 3000) {
      tier = "Covert tier: Inner Circle";
      chip = "Rare drop";
      sub = "This is what happens when campaign enthusiasm exceeds all reasonable internal controls. Valid through April 7.";
    } else if (credits >= 1000) {
      tier = "Covert tier: Strong Believer";
      chip = "Elevated drop";
      sub = "Apparently your trust in unauthorized analog expansion plans has been rewarded. Valid through April 7.";
    }

    return {
      credits,
      tier,
      chip,
      sub
    };
  }

    function formatCreditsWorth(credits) {
     return (Number(credits) / 100).toFixed(2);
  }

  function pickQuote() {
    return quotes[Math.floor(Math.random() * quotes.length)];
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function encodeRFC3986(str) {
    return encodeURIComponent(String(str))
      .replace(/!/g, "%21")
      .replace(/'/g, "%27")
      .replace(/\(/g, "%28")
      .replace(/\)/g, "%29")
      .replace(/\*/g, "%2A");
  }

  function toBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  async function generateShopifySupportSignature({ method, pathWithQuery, body, token }) {
    const canonical =
      String(method || "GET").toUpperCase() +
      "\n" +
      String(pathWithQuery || "") +
      "\n" +
      (body == null ? "" : String(body));

    const encoder = new TextEncoder();

    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      encoder.encode(token),
      { name: "HMAC", hash: "SHA-256" },
      false,
      ["sign"]
    );

    const signatureBuffer = await crypto.subtle.sign(
      "HMAC",
      cryptoKey,
      encoder.encode(canonical)
    );

    return {
      canonical,
      signature: toBase64(signatureBuffer)
    };
  }

  function getQueuedRewardSync() {
    try {
      return JSON.parse(localStorage.getItem(REWARD_SYNC_QUEUE_KEY) || "null");
    } catch (e) {
      return null;
    }
  }

  function queueRewardSync(payload) {
    try {
      localStorage.setItem(REWARD_SYNC_QUEUE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function clearRewardSyncQueue() {
    try {
      localStorage.removeItem(REWARD_SYNC_QUEUE_KEY);
    } catch (e) {}
  }

  async function submitRewardToActivityApi(email, points, message) {
    const payload = {
      email,
      activityId: ACTIVITY_ID,
      points: Number(points),
      message: String(message || "")
    };

    const body = JSON.stringify(payload);

    const signed = await generateShopifySupportSignature({
      method: "POST",
      pathWithQuery: ACTIVITY_API_PATH,
      body,
      token: ACTIVITY_SIGN_TOKEN
    });



    const response = await fetch(ACTIVITY_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-SHOPIFY-SUPPORT-SIGNATURE": signed.signature
      },
      body
    });

    const text = await response.text();
    let data = null;

    try {
      data = JSON.parse(text);
    } catch (e) {}

    if (!response.ok) {
      throw new Error(data?.message || data?.msg || text || `Request failed with status ${response.status}`);
    }

    return data;
  }


  function showClaimError(message) {
    const claimBox = document.querySelector(".bp-claim__form-compact");
    if (!claimBox) {
      if (message) alert(message);
      return;
    }

    let errorEl = document.getElementById("bp-claim-error-js");
    if (!errorEl) {
      errorEl = document.createElement("div");
      errorEl.id = "bp-claim-error-js";
      errorEl.style.marginTop = "10px";
      errorEl.style.fontSize = "13px";
      errorEl.style.lineHeight = "1.6";
      errorEl.style.color = "#b42318";
      claimBox.appendChild(errorEl);
    }

    errorEl.textContent = message || "";
    errorEl.style.display = message ? "block" : "none";
  }

  function setClaimSubmitting(isSubmitting) {
    claimSubmitting = isSubmitting;

    const root = document.querySelector(".klaviyo-form-WiaUdU");
    if (!root) return;

    const submitBtn =
      root.querySelector('button[type="submit"]') ||
      root.querySelector('input[type="submit"]') ||
      root.querySelector("button");

    const emailInput =
      root.querySelector('input[type="email"]') ||
      root.querySelector('input[name="email"]');

    if (submitBtn) {
      submitBtn.disabled = isSubmitting;
      submitBtn.style.opacity = isSubmitting ? "0.7" : "1";
      submitBtn.style.cursor = isSubmitting ? "not-allowed" : "";

      if (submitBtn.tagName === "BUTTON") {
        submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent;
        submitBtn.textContent = isSubmitting ? "Submitting..." : submitBtn.dataset.originalText;
      } else if (submitBtn.tagName === "INPUT") {
        submitBtn.dataset.originalValue = submitBtn.dataset.originalValue || submitBtn.value;
        submitBtn.value = isSubmitting ? "Submitting..." : submitBtn.dataset.originalValue;
      }
    }

    if (emailInput) {
      emailInput.disabled = isSubmitting;
    }
  }

  function spinRewardSlot(value) {
    const slot = document.getElementById("bp-claim-reward-slot");
    const rewardCard = document.getElementById("bp-claim-reward-card");
    if (!slot) return;

    const digits = String(value).padStart(4, "0").split("");
    const strips = slot.querySelectorAll(".bp-slot__digit .bp-slot__strip");
    const digitHeight = window.innerWidth <= 989 ? 62 : 74;

    const stopOrder = [3, 2, 1, 0];
    let longestDuration = 0;

    stopOrder.forEach((digitIndex, orderIndex) => {
      const strip = strips[digitIndex];
      if (!strip) return;

      const target = Number(digits[digitIndex] || 0);
      strip.innerHTML = "";

      const loops = 5 + (stopOrder.length - 1 - orderIndex) * 3;
      const sequence = [];

      for (let l = 0; l < loops; l++) {
        for (let n = 0; n <= 9; n++) {
          sequence.push(n);
        }
      }

      for (let n = 0; n <= target; n++) {
        sequence.push(n);
      }

      sequence.forEach((num) => {
        const span = document.createElement("span");
        span.textContent = String(num);
        strip.appendChild(span);
      });

      const duration = 1000 + orderIndex * 520;
      longestDuration = Math.max(longestDuration, duration);

      const finalY = -((sequence.length - 1) * digitHeight);
      const overshootY = finalY - Math.round(digitHeight * 0.22);

      strip.style.transition = "none";
      strip.style.transform = "translateY(0px)";

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          strip.style.transition = `transform ${duration}ms cubic-bezier(.12,.78,.18,1)`;
          strip.style.transform = `translateY(${overshootY}px)`;

          setTimeout(() => {
            strip.style.transition = "transform 220ms cubic-bezier(.22,1.2,.35,1)";
            strip.style.transform = `translateY(${finalY}px)`;
          }, duration);
        });
      });
    });

    if (rewardCard) {
      rewardCard.classList.remove("is-celebrating");
      void rewardCard.offsetWidth;

      setTimeout(() => {
        rewardCard.classList.add("is-celebrating");
      }, Math.max(longestDuration - 80, 0));

      setTimeout(() => {
        rewardCard.classList.remove("is-celebrating");
      }, longestDuration + 900);
    }
  }
    function buildActivityMessage(tierName, quote) {
      return `${String(tierName || "").trim()}-${String(quote || "").trim()}`;
    }

    async function flushQueuedRewardSync() {
      const queued = getQueuedRewardSync();
      if (!queued || !queued.email || typeof queued.points === "undefined") return;

      try {
        await submitRewardToActivityApi(
          queued.email,
          queued.points,
          queued.quote
        );
        clearRewardSyncQueue();
      } catch (e) {
        console.error("Queued activity sync failed:", e);
      }
    }


  function storeUnlock(payload) {
    try {
      localStorage.setItem(REWARD_KEY, JSON.stringify(payload.reward));
      localStorage.setItem(REWARD_UNLOCK_KEY, JSON.stringify({
        unlocked: true,
        tierName: payload.tierName,
        pledgeAmount: payload.pledgeAmount,
        reward: payload.reward,
        supporterNumber: payload.supporterNumber,
        quote: payload.quote,
        unlockedAt: Date.now()
      }));
    } catch (e) {}
  }

  function openModal() {
    modalEl.classList.add("is-open");
    modalEl.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    showTierStep();
  }

  function closeModal() {
    modalEl.classList.remove("is-open");
    modalEl.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    pendingClaim = null;
    showTierStep();

    if (claimSuccessNoteEl) claimSuccessNoteEl.hidden = true;
    if (claimFormCompactEl) claimFormCompactEl.style.display = "";
    if (claimSuccessEmailEl) claimSuccessEmailEl.textContent = "";

    showClaimError("");
    setClaimSubmitting(false);
    showClaimSubmitButton();
    stopKlaviyoWatcher();
  }

  function showTierStep() {
    if (stepTiersEl) stepTiersEl.hidden = false;
    if (stepRevealNoticeEl) stepRevealNoticeEl.hidden = true;
    if (stepClaimEl) stepClaimEl.hidden = true;
  }

  function showRevealNoticeStep() {
    if (stepTiersEl) stepTiersEl.hidden = true;
    if (stepRevealNoticeEl) stepRevealNoticeEl.hidden = false;
    if (stepClaimEl) stepClaimEl.hidden = true;
  }

  function showClaimStep() {
    if (stepTiersEl) stepTiersEl.hidden = true;
    if (stepRevealNoticeEl) stepRevealNoticeEl.hidden = true;
    if (stepClaimEl) stepClaimEl.hidden = false;
  }

  function buildClaimData(tierName, pledgeAmount) {
    return {
      tierName,
      pledgeAmount,
      reward: weightedReward(),
      supporterNumber: state.backers + 1,
      quote: pickQuote()
    };
  }

  function fillClaimStep(data) {
  if (!data) return;

  const rewardWorthEl = document.getElementById("bp-claim-reward-worth");
  const worth = formatCreditsWorth(data.reward.credits);

  if (claimRewardEl) {
    claimRewardEl.textContent = String(data.reward.credits).padStart(4, "0");
  }

  if (claimQuoteEl) {
    claimQuoteEl.textContent = data.quote;
  }

  if (rewardWorthEl) {
    rewardWorthEl.hidden = true;
    rewardWorthEl.classList.remove("is-visible");
    rewardWorthEl.textContent = `Worth $${worth} toward your next order`;
  }

  spinRewardSlot(data.reward.credits);

  setTimeout(() => {
    if (rewardWorthEl) {
      rewardWorthEl.hidden = false;
      requestAnimationFrame(() => {
        rewardWorthEl.classList.add("is-visible");
      });
    }
  }, 2700);

  if (claimSuccessNoteEl) claimSuccessNoteEl.hidden = true;
  showClaimError("");
  setClaimSubmitting(false);
}

  function goToReveal() {
    if (!pendingClaim) return;
    showRevealNoticeStep();

    const noticeTitle = document.getElementById("bp-reveal-title");
    const noticeText = document.getElementById("bp-reveal-text");

  }

  function getClaimSubmitButton() {
    const root = document.querySelector(".klaviyo-form-WiaUdU");
    if (!root) return null;

    return Array.from(root.querySelectorAll("button")).find((btn) =>
      (btn.textContent || "").trim().toLowerCase() === "claim my credits"
    ) || null;
  }

  function hideClaimSubmitButton() {
    const btn = getClaimSubmitButton();
    if (btn) btn.style.display = "none";
  }

  function showClaimSubmitButton() {
    const btn = getClaimSubmitButton();
    if (btn) btn.style.display = "";
  }

async function handleClaimSubmitWithEmail(email) {
  if (!pendingClaim) {
    showClaimError("Reward data expired. Please back a tier again.");
    return;
  }

  const normalizedEmail = String(email || "").trim().toLowerCase();

  if (!isValidEmail(normalizedEmail)) {
    showClaimError("Please enter a valid email address.");
    return;
  }

  if (claimSubmitting) return;

  showClaimError("");
  setClaimSubmitting(true);

  try {
    const result = await submitRewardToActivityApi(
      normalizedEmail,
      pendingClaim.reward.credits,
      buildActivityMessage(pendingClaim.tierName, pendingClaim.quote)
    );

    const apiData = result?.data ?? result;

    if (apiData === false) {
      if (claimSuccessNoteEl) {
        claimSuccessNoteEl.hidden = true;
      }

      showClaimError("This email has already claimed the reward points.");
      return;
    }

    storeUnlock(pendingClaim);

    if (claimFormCompactEl) {
       claimFormCompactEl.style.display = "none";
    }

    if (claimSuccessEmailEl) {
       claimSuccessEmailEl.textContent = normalizedEmail;
    }

    if (claimSuccessNoteEl) {
       claimSuccessNoteEl.hidden = false;
    }

   hideClaimSubmitButton();
   clearRewardSyncQueue();

    state.amount += pendingClaim.pledgeAmount;
    state.backers += 1;
    state.supportCount += 1;
    render();

    const successMsg = `New supporter added: ${pendingClaim.tierName} · Reward ${String(
      pendingClaim.reward.credits
    ).padStart(4, "0")} points claimed`;
    showUpdate(successMsg);
  } catch (error) {
    console.error("Activity reward submit failed:", error);

    queueRewardSync({
      email: normalizedEmail,
      points: pendingClaim.reward.credits,
      tierName: pendingClaim.tierName,
      pledgeAmount: pendingClaim.pledgeAmount,
      reward: pendingClaim.reward,
      supporterNumber: pendingClaim.supporterNumber,
      quote: buildActivityMessage(pendingClaim.tierName, pendingClaim.quote),
      queuedAt: Date.now()
    });


    storeUnlock(pendingClaim);

   if (claimSuccessNoteEl) {
      claimSuccessNoteEl.hidden = true;
  }

    showClaimError(
      "Network issue detected. Your reward was saved and will retry automatically."
    );

    state.amount += pendingClaim.pledgeAmount;
    state.backers += 1;
    state.supportCount += 1;
    render();
  } finally {
    setClaimSubmitting(false);
  }
}

  function bindKlaviyoFormSubmission(root) {
    if (!root || root.dataset.bpBound === "true") return;
    root.dataset.bpBound = "true";

    const getEmail = () => {
      const emailInput =
        root.querySelector('input[type="email"]') ||
        root.querySelector('input[name="email"]');
      return emailInput ? emailInput.value : "";
    };

    const handleIntercept = async (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }

      const email = getEmail();
      console.log("[BP] intercepted claim", { email, pendingClaim });

      await handleClaimSubmitWithEmail(email);
      return false;
    };

    root.addEventListener(
      "submit",
      async (event) => {
        console.log("[BP] submit captured on root");
        await handleIntercept(event);
      },
      true
    );

    root.addEventListener(
      "click",
      async (event) => {
        const target = event.target.closest(
          'button[type="submit"], input[type="submit"], button'
        );
        if (!target) return;

        console.log("[BP] submit click captured", target);
        await handleIntercept(event);
      },
      true
    );

    console.log("[BP] Klaviyo root bound");
  }

  function tryBindKlaviyoForm() {
    const root = document.querySelector(".klaviyo-form-WiaUdU");
    console.log("[BP] tryBindKlaviyoForm root", root);
    if (!root) return false;

    const emailInput =
      root.querySelector('input[type="email"]') ||
      root.querySelector('input[name="email"]');

    const submitBtn =
      root.querySelector('button[type="submit"]') ||
      root.querySelector('input[type="submit"]') ||
      root.querySelector("button");

    console.log("[BP] tryBindKlaviyoForm found", { emailInput, submitBtn });

    if (emailInput && submitBtn) {
      bindKlaviyoFormSubmission(root);
      return true;
    }

    return false;
  }

  function stopKlaviyoWatcher() {
    if (klaviyoWatchTimer) {
      clearInterval(klaviyoWatchTimer);
      klaviyoWatchTimer = null;
    }
  }

  function watchKlaviyoForm() {
    stopKlaviyoWatcher();

    if (tryBindKlaviyoForm()) return;

    let attempts = 0;
    klaviyoWatchTimer = setInterval(() => {
      attempts += 1;
      const done = tryBindKlaviyoForm();

      if (done || attempts > 100) {
        stopKlaviyoWatcher();
      }
    }, 300);
  }

  function setupMutationWatcher() {
    const root = document.querySelector(".klaviyo-form-WiaUdU");
    if (!root || root.dataset.bpObserverBound === "true") return;

    root.dataset.bpObserverBound = "true";

    const observer = new MutationObserver(() => {
      tryBindKlaviyoForm();
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  function handleTierButtonClick(button) {
    if (!button) return;

    const tierName =
      button.dataset.tierName ||
      button.getAttribute("data-tier-name") ||
      button.getAttribute("data-tier") ||
      "Covert Support Tier";

    const pledgeAmount = Number(
      button.dataset.pledgeAmount ||
      button.getAttribute("data-pledge-amount") ||
      button.getAttribute("data-tier-amount") ||
      button.getAttribute("data-amount") ||
      0
    );

    pendingClaim = buildClaimData(tierName, pledgeAmount);
    goToReveal();
  }

  function bindTierButtons() {
    const tierButtons = document.querySelectorAll("[data-bp-tier-select]");
    tierButtons.forEach((button) => {
      if (button.dataset.bpClickBound === "true") return;
      button.dataset.bpClickBound = "true";

      button.addEventListener("click", () => {
        handleTierButtonClick(button);
      });
    });
  }

  function restoreUnlockedReward() {
    let unlocked = null;
    try {
      unlocked = JSON.parse(localStorage.getItem(REWARD_UNLOCK_KEY) || "null");
    } catch (e) {
      unlocked = null;
    }

    if (!unlocked || !unlocked.unlocked || !unlocked.reward) return;

    pendingClaim = {
      tierName: unlocked.tierName,
      pledgeAmount: unlocked.pledgeAmount,
      reward: unlocked.reward,
      supporterNumber: unlocked.supporterNumber,
      quote: unlocked.quote || pickQuote()
    };
  }

  function setupModalEvents() {
    const closeButtons = modalEl.querySelectorAll("[data-bp-modal-close]");
    closeButtons.forEach((btn) => {
      btn.addEventListener("click", closeModal);
    });

    modalEl.addEventListener("click", (e) => {
      if (e.target === modalEl) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modalEl.classList.contains("is-open")) {
        closeModal();
      }
    });
  }

  function setupClaimFlowButtons() {
    const openButtons = document.querySelectorAll("[data-bp-open-modal]");
    openButtons.forEach((button) => {
      button.addEventListener("click", openModal);
    });

    const revealBtn = document.getElementById("bp-confirm-reveal");
    if (revealBtn) {
      revealBtn.addEventListener("click", () => {
        if (!pendingClaim) return;
        showClaimStep();
        fillClaimStep(pendingClaim);
        watchKlaviyoForm();
        setupMutationWatcher();
      });
    }

    if (openClaimStepBtn) {
      openClaimStepBtn.addEventListener("click", () => {
        if (!pendingClaim) return;
        showClaimStep();
        fillClaimStep(pendingClaim);
        watchKlaviyoForm();
        setupMutationWatcher();
      });
    }
  }

  function setupDemoFallbackTierButtons() {
    const fallbackButtons = document.querySelectorAll(
      "[data-tier-name][data-pledge-amount], [data-tier-name][data-tier-amount]"
    );
    fallbackButtons.forEach((button) => {
      if (button.dataset.bpFallbackBound === "true") return;
      if (button.hasAttribute("data-bp-tier-select")) return;

      button.dataset.bpFallbackBound = "true";
      button.addEventListener("click", () => handleTierButtonClick(button));
    });
  }

function setupSharePanel() {
  const trigger = document.getElementById("bp-share-trigger");
  const modal = document.getElementById("bp-share-modal");
  const copyBtn = document.getElementById("bp-share-copy");
  const xLink = document.getElementById("bp-share-x");
  const facebookLink = document.getElementById("bp-share-facebook");
  const redditLink = document.getElementById("bp-share-reddit");
  const whatsappLink = document.getElementById("bp-share-whatsapp");
  const emailLink = document.getElementById("bp-share-email");

  if (!trigger || !modal) return;

  const closeButtons = modal.querySelectorAll("[data-bp-share-close]");
  const shareUrl = window.location.href;
  const shareTitle = "The Analog Collection by Beyond Power";
  const shareText = "This campaign may reflect varying degrees of realism. Back the Analog Collection.";

  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(shareTitle);
  const encodedText = encodeURIComponent(shareText);

  if (xLink) {
    xLink.href = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
  }

  if (facebookLink) {
    facebookLink.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  }

  if (redditLink) {
    redditLink.href = `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`;
  }

  if (whatsappLink) {
    whatsappLink.href = `https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`;
  }

  if (emailLink) {
    emailLink.href = `mailto:?subject=${encodedTitle}&body=${encodeURIComponent(shareText + "\n\n" + shareUrl)}`;
  }

  function openShareModal() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    trigger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }

  function closeShareModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    trigger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  trigger.addEventListener("click", (event) => {
    event.preventDefault();
    openShareModal();
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeShareModal);
  });

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      closeShareModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeShareModal();
    }
  });

  if (copyBtn) {
    copyBtn.addEventListener("click", async () => {
      const label = copyBtn.querySelector(".bp-share-tile__label");

      try {
        await navigator.clipboard.writeText(shareUrl);
        copyBtn.classList.add("is-copied");
        if (label) label.textContent = "Copied";
      } catch (e) {
        const temp = document.createElement("input");
        temp.value = shareUrl;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand("copy");
        document.body.removeChild(temp);
        copyBtn.classList.add("is-copied");
        if (label) label.textContent = "Copied";
      }

      setTimeout(() => {
        copyBtn.classList.remove("is-copied");
        if (label) label.textContent = "Copy Link";
      }, 1600);
    });
  }
}

  function runAutoBootAnimation() {
    if (state.autoBootDone) {
      render();
      return;
    }

    animateTo(AUTO_TARGET, AUTO_BACKERS_TARGET, AUTO_DURATION, () => {
      state.autoBootDone = true;
      saveState();
    });
  }

  function init() {
    render();
    runAutoBootAnimation();
    cycleLiveMessages();
    passiveGrowthLoop();
    restoreUnlockedReward();
    setupModalEvents();
    setupClaimFlowButtons();
    bindTierButtons();
    setupDemoFallbackTierButtons();
    setupSharePanel();
    flushQueuedRewardSync();

    window.addEventListener("online", () => {
      flushQueuedRewardSync();
    });

    setInterval(() => {
      flushQueuedRewardSync();
    }, 15000);
  }

  init();
})();